import {iterateNodes, addOrRemoveClass} from './dom';

export default class ResizeHandler {
    constructor(breakpointSettings) {
        this.previousWidth = window.innerWidth;

        breakpointSettings.map(setting => ResizeHandler.evaluateInitialViewport(setting));
        window.addEventListener('resize', () => this.createResizePromises(breakpointSettings));
    }

    static evaluateInitialViewport(breakpointSetting) {
        let evaluatedSetting = ResizeHandler.evaluateSetting(breakpointSetting);
        let {breakpointWidth, selector, extraCondition, directionDown, evaluateInitial} = evaluatedSetting;

        if(document.querySelectorAll(selector).length === 0){
            return;
        }

        let currentWidth = window.innerWidth;
        let breakpointCondition = directionDown ? currentWidth <= breakpointWidth : currentWidth >= breakpointWidth;

        if (eval(extraCondition) && breakpointCondition && evaluateInitial) {
            iterateNodes(selector, addOrRemoveClass, breakpointSetting);
        }
    }

    static evaluateSetting(breakpointSetting) {
        let breakpointWidth = breakpointSetting.width || 0;
        let selector = breakpointSetting.selector || '';
        let extraCondition = breakpointSetting.extraCondition || true;
        let evaluateInitial = breakpointSetting.evaluateInitial !== false;
        let emitEvent = breakpointSetting.emitEvent || false;

        // whether the class change should happen on sizing the window up or sizing it down
        let directionDown = breakpointSetting.direction === 'down' || false;

        return {breakpointWidth, selector, extraCondition, directionDown, evaluateInitial, emitEvent};
    }

    createResizePromises(breakpoints) {
        let resizePromises = breakpoints.map(setting =>
            new Promise((resolve) => {
                this.changeClass(setting);
                resolve();
            })
        );

        Promise.all(resizePromises).then(() => this.previousWidth = window.innerWidth);
    }

    changeClass(breakpointSetting) {
        let evaluatedSetting = ResizeHandler.evaluateSetting(breakpointSetting);
        let {breakpointWidth, selector, extraCondition, directionDown, emitEvent} = evaluatedSetting;

        if(document.querySelectorAll(selector).length === 0){
            return;
        }

        let currentWidth = window.innerWidth;
        let wasAboveBreakpointBefore = this.previousWidth > breakpointWidth;
        let wasWiderBefore = this.previousWidth > currentWidth;
        let isUnderBreakpoint = currentWidth <= breakpointWidth;

        let wasResizedInSpecifiedDirection = directionDown ? wasWiderBefore : !wasWiderBefore;
        let wasResizedBeyondBreakpoint = directionDown ? isUnderBreakpoint && wasAboveBreakpointBefore : !isUnderBreakpoint && !wasAboveBreakpointBefore;

        if (eval(extraCondition) && wasResizedInSpecifiedDirection && wasResizedBeyondBreakpoint) {
            if(emitEvent !== false){
                let e = new Event(emitEvent);
                window.dispatchEvent(e);
            }

            iterateNodes(selector, addOrRemoveClass, breakpointSetting);
        }
    }
}